import { render, staticRenderFns } from "./ForgotPasswordAction.vue?vue&type=template&id=3af78d52&"
import script from "./ForgotPasswordAction.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports